/**
 * This function provides the smart functions route based on the provided parameters.
 */
export const getSmartFunctionsRoute = (installationId = ':installationId', storageId = ':storageId', url?: string): string => {
  if (url) {
    return `${url}/properties/smart-functions`
  }
  return `/installation/${installationId}/${storageId}/properties/smart-functions`
}

/**
 * This function provides the smart charge route for a farm server or normal installation based on the provided parameters.
 */
export const getSmartChargeRoute = (installationId = ':installationId', storageId = ':storageId', url?: string): string => {
  if (url) {
    return `${url}/properties/smart-functions/smart-charge`
  }
  return `/installation/${installationId}/${storageId}/properties/smart-functions/smart-charge`
}

/**
 * This function provides the smart home route for a farm server or normal installation based on the provided parameters.
 */
export const getSmartHomeRoute = (installationId = ':installationId', storageId = ':storageId', url?: string): string => {
  if (url) {
    return `${url}/properties/smart-functions/smart-home`
  }
  return `/installation/${installationId}/${storageId}/properties/smart-functions/smart-home`
}

/**
 * This function provides the smart power route for a farm server or normal installation based on the provided parameters.
 */
export const getSmartPowerRoute = (installationId = ':installationId', storageId = ':storageId', url?: string): string => {
  if (url) {
    return `${url}/properties/smart-functions/smart-power`
  }
  return `/installation/${installationId}/${storageId}/properties/smart-functions/smart-power`
}

/**
 * This function provides the smart power route for a farm client member based on the provided parameters.
 */
export const getSmartPowerClientsRoute = (
  installationId = ':installationId',
  storageId = ':storageId',
  childStorageId = ':childStorageId',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/smart-functions/smart-power`
  }
  return `/installation/${installationId}/${storageId}/properties/smart-functions/${childStorageId}/smart-power`
}

/**
 * This function provides the route for a farm member based on the provided parameters.
 */
export const getSmartPowerRouteForFarmMember = (
  index: number,
  installationId: string | undefined,
  storageId: string | undefined,
  farmMemberStorageId: string
): string => {
  if (index === 0) {
    return getSmartPowerRoute(installationId, storageId)
  }
  return getSmartPowerClientsRoute(installationId, storageId, farmMemberStorageId)
}
